import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';

export default {
	name: 'DaisyEMPbS',
	friendly_name: 'Shelly Daisy EM',
	family: 'emeter',
	isPM: true,
	gen: 2,
	modes: {
		emeter: {
			channels: 1,
			phases: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'appliance_type', component: 'appliance_type' },
						{
							title: 'consumption_calculation',
							component: 'consumption_calculation',
						},
					],
				},
				share,
				{
					title: 'tariff_configuration',
					components: [{ title: 'tariff_tables', component: 'daisy_em_tariff' }],
				},
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'device_name', component: 'device_name_g2' },
						{
							title: 'reverse_measurement_direction',
							component: 'reverse_measurement_direction_monophase',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'delete_stored_data', component: 'delete_stored_data_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
